import axios from "axios";
import { React, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { styled } from "styled-components";
import Loader from "../components/Loader";
import CollectionCard from "../components/collections/CollectionCard";
import CreateCollectionCard from "../components/collections/CreateCollectionCard";
const Container = styled.div`
  display: flex;
  padding: 0px 20px 40px 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  flex: 1 auto;
  align-self: stretch;
`;
const CollectionGrid = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: space-evenly;
`;
const LoadMoreSection = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  justify-content: space-evenly;
  padding: 40px 0px 40px 0px;
`;
const LoadMoreButton = styled.button`
  font-size: 18px;
  padding: 5px;
  border: 1px solid ${({ theme }) => theme.colorPrimary};
  background-color: ${({ theme }) => theme.colorPrimary};
  color: ${({ theme }) => theme.colorOnBackground};
  border-radius: 8px;
  font-weight: 500;
  margin-top: 10px;
  cursor: pointer;
  &:hover {
    background-color: transparent;
    color: ${({ theme }) => theme.colorPrimary};
  }
`;
const PAGE_SIZE = 12;

const Collections = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [collections, setCollections] = useState([]);
  const [nextOffset, setNextOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (!currentUser?._id) return;
    const fetchCollections = async () => {
      setIsLoading(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_RECIPE_API_BASE_URL}/collections/user/${currentUser._id}?offset=0&limit=${PAGE_SIZE}`,
          { withCredentials: true }
        );
        setCollections(res.data);
        setNextOffset(res.data.length);
        setHasMore(res.data.length === PAGE_SIZE);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCollections();
  }, [currentUser]);
  const fetchMoreData = () => {
    if (!currentUser?._id) return;
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_RECIPE_API_BASE_URL}/collections/user/${currentUser._id}?offset=${nextOffset}&limit=${PAGE_SIZE}`,
        { withCredentials: true }
      )
      .then((res) => {
        setCollections((prev) => [...prev, ...res.data]);
        setNextOffset((o) => o + res.data.length);
        setHasMore(res.data.length === PAGE_SIZE);
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };
  return (
    <Container>
      <CollectionGrid>
        <CreateCollectionCard />
        {collections.map((collection, index) => (
          <CollectionCard
            key={collection._id + index}
            collection={collection}
          />
        ))}
      </CollectionGrid>
      <LoadMoreSection>
        {isLoading && <Loader />}
        {hasMore && !isLoading ? (
          <LoadMoreButton onClick={fetchMoreData}>Load More</LoadMoreButton>
        ) : (
          <p>You've reached the end. Wow!</p>
        )}
      </LoadMoreSection>
    </Container>
  );
};
export default Collections;
